<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let labelText = '';
  export let value = false;
  let randId = () => '_' + Math.random().toString(36).substr(2, 9);
  let checkboxId = randId();
  let input = (e) => {
    dispatch('input');
  };
</script>

<div class="checkbox-wrapper">
  {#if labelText !== ''}
    <label for={checkboxId}>{labelText}</label>
  {/if}
  <input type="checkbox" id={checkboxId} on:input={input} bind:checked={value} />
</div>

<style>.checkbox-wrapper{display:flex;justify-content:space-between;margin-bottom:1em}.checkbox-wrapper>label{color:var(--t-c);text-transform:capitalize}input[type=checkbox]{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#eee;border:0;border-radius:100px;box-sizing:border-box;color:var(--t-l-c);cursor:pointer;height:20px;padding:8px;position:relative;transition:all .1s;transition:background-color .2s;vertical-align:middle;width:40px}input[type=checkbox]:before{background-color:var(--t-c);border-radius:50%;bottom:2px;box-shadow:0 1px 3px rgba(0,0,0,.3);content:"";height:16px;left:4px;position:absolute;top:2px;transition:transform .2s cubic-bezier(.01,.65,.23,1);width:16px;will-change:transform}input[type=checkbox]:checked{background-color:var(--h-c)}input[type=checkbox]:checked:before{background-color:#fff;transform:translateX(100%)}</style>
